export default __webpack_public_path__ + "static/media/Scan.563f6c4b.jpeg";